import { render, staticRenderFns } from "./base-field-checkbox.vue?vue&type=template&id=a58b0a62&"
import script from "./base-field-checkbox.vue?vue&type=script&lang=js&"
export * from "./base-field-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports